const header = {
  homepage: 'https://shujaatazim.com/',
  title: 'SA.',
}

const about = {
  name: 'Shujaat Azim',
  role: 'Full Stack Developer & Software Engineer',
  description:
    `I've worked as a full-stack developer since 2019, following a career path that has also included medicine, finance, and technology. 
    Taking an unconventional route exposed me to different ways of thinking and solving problems, and I'm grateful for the perspective 
    those experiences provided. Today, I bring that same adaptability and eagerness to learn to every project, always looking for better 
    ways to build software and continue growing as an engineer.`,
  social: {
    linkedin: 'https://www.linkedin.com/in/shujaatazim/',
    github: 'https://github.com/ShujaatAzim',
    blog: 'https://dev.to/shujaatazim',
    resume: 'ShujaatAzimCV.pdf'
  },
}

const projects = [
  {
    name: 'PokéBook',
    description:
      `A full-stack application for managing Pokémon card collections, built with a Rails API and React frontend. Designed around secure read-only 
      sharing links, responsive collection browsing, and a maintainable architecture that can grow alongside new features.`,
    stack: ['Vite', 'React', 'Rails', 'Javascript', 'Ruby'],
    sourceCode: 'https://github.com/ShujaatAzim/PokeBook-Frontend',
    live: 'https://pokebook.shujaatazim.com',
  },
  {
    name: 'TweedleDoo',
    description:
      `A full-stack task management application focused on simplicity and usability. Supports multiple lists with complete CRUD functionality while 
      emphasizing clean data modeling, intuitive interactions, and maintainable full-stack architecture.`,
    stack: ['React', 'Rails', 'Javascript', 'Ruby'],
    sourceCode: 'https://github.com/ShujaatAzim/TweedleDoo-Frontend',
    live: 'https://tweedledoo.shujaatazim.com',
  },
  {
    name: 'Roshambo',
    description:
      `A browser-based Rock, Paper, Scissors game built entirely with vanilla JavaScript, HTML, and CSS. Created to demonstrate strong JavaScript 
      fundamentals and thoughtful application structure without relying on external framework. "Roshambo" is another name for the popular game, 
      especially on the west coast of the US.`,
    stack: ['Javascript', 'Vite', 'HTML', 'CSS'],
    sourceCode: 'https://github.com/ShujaatAzim/Roshambo',
    live: 'https://roshambo.shujaatazim.com',
  },
  {
    name: 'City Skyline',
    description:
      `An interactive city skyline built primarily with CSS, featuring animated lighting, weather effects, and responsive layouts. Created as an 
      exploration of advanced CSS techniques, demonstrating how polished interfaces can be achieved with minimal JavaScript.`,
    stack: ['CSS', 'HTML', 'Javascript', 'Vite'],
    sourceCode: 'https://github.com/ShujaatAzim/CitySkyline',
    live: 'https://cityskyline.shujaatazim.com',
  },
  {
    name: 'Hacker News Search',
    description:
      `A lightweight Hacker News search application built during a timed coding challenge. Demonstrates rapid API integration, clean React component 
      design, and delivering maintainable software under real-world time constraints.`,
    stack: ['Vite', 'React', 'Javascript', 'API'],
    sourceCode: 'https://github.com/ShujaatAzim/HackerNewsSearch',
    live: 'https://hnsearch.shujaatazim.com',
  },
  {
    name: 'Ruby Tidbits',
    description:
      `A collection of classic programming exercises implemented with Ruby on Rails, including palindrome detection and prime factorization. Focused 
      on algorithmic problem-solving, clean Ruby code, and straightforward application design.`,
    stack: ['Rails', 'Ruby'],
    sourceCode: 'https://github.com/ShujaatAzim/RubyTidbits',
    live: 'https://tidbits.shujaatazim.com',
  }
]

const enterprise = [
  {
    name: 'The Phoenix site',
    link: ''
  },
  {
    name: 'NewForm Portal',
    link: ''
  },
  {
    name: 'NewForm site',
    link: ''
  }
]

const skills = [
  {
    name: 'Languages',
    skills: [
      'Javascript',
      'Typescript',
      'Ruby',
      'Python',
      'C',
      'HTML',
      'CSS'
    ]
  },
  {
    name: 'Frameworks',
    skills: [
      'Next',
      'React',
      'Vite',
      'Nest',
      'Rails',
      'Vue'
    ],
  },
  {
    name: 'Libraries',
    skills: [
      'Tailwind',
      'Jotai',
      'Recoil',
      'D3'
    ],
  },
  {
    name: 'Tools',
    skills: [
      'Node',
      'Git',
      'Figma',
      'SQLite',
      'PostgreSQL',
      'GraphQL',
      'REST API',
      'Postman',
      'Insomnia'
    ],
  },
  {
    name: 'Platforms',
    skills: [
      'AWS',
      'Hasura',
      'Firebase',
      'Heroku',
      'Dokku'
    ],
  },
  {
    name: 'Testing',
    skills: [
      'Playwright',
      'Jest',
      'RSpec'
    ]
  }
];

const certificates = [
  {
    name: 'Flatiron',
    image: '/FlatironCertImg.png',
    pdf: '/FlatironCertificate.pdf'
  },
  {
    name: 'freeCodeCamp Responsive',
    image: '/fCCResponsiveCertImg.png',
    pdf: '/fCCResponsiveCertificate.pdf'
  }
]

const contact = {
  email: 'shujaatazim@gmail.com',
}

export { header, about, projects, enterprise, skills, certificates, contact }
